(ns dashboard.views.settings.events
  (:require
   [reagent.core :as reagent]
   [re-frame.core :as re-frame]
   [dashboard.i18n :refer [tr]]
   [dashboard.subs :as subs]
   [dashboard.subs.event-organizer :as event-organizer-subs]
   [dashboard.utils :refer [listen vec-remove index-of format-day]]
   [dashboard.events.events :as event-events]
   [dashboard.components.datepicker :refer [datepicker]]
   [dashboard.components.select :refer [time-select]]
   [dashboard.components.drawer :refer [drawer]]
   [dashboard.components.dialog :refer [dialog]]
   [dashboard.components.button :refer [button]]
   [dashboard.components.inputs :refer [input]]
   [dashboard.components.table :refer [table]]
   [dashboard.components.tag :refer [tag]]
   ["date-fns" :refer [formatISO formatDistance parse format addDays isSameDay]]
   ["@heroicons/react/solid" :refer [XIcon PencilIcon]]))

(defn- event-drawer-content [{:keys [state]}]
  [:div.relative.mt-6.flex-1

   [:div.space-y-1.sm:grid.sm:grid-cols-4.sm:gap-2.sm:space-y-0
    [:div
     [:label.block.text-sm.font-medium.text-gray-900.sm:mt-px.sm:pt-2
      (tr :event/name)]]
    [:div.sm:col-span-3
     [input
      {:auto-complete "name"
       :name "name"
       :type "text"
       :disabled? (= (:action @state) :view)
       :default-value (get-in @state [:event :name])
       :on-change #(swap! state assoc-in [:event :name] %)}]]]

   [:div.space-y-1.sm:grid.sm:grid-cols-4.sm:gap-2.sm:space-y-0
    [:div
     [:label.block.text-sm.font-medium.text-gray-900.sm:mt-px.sm:pt-2
      (tr :event/nameJp)]]
    [:div.sm:col-span-3
     [input
      {:auto-complete "name"
       :name "name"
       :type "text"
       :disabled? (= (:action @state) :view)
       :default-value (get-in @state [:event :nameJp])
       :on-change #(swap! state assoc-in [:event :nameJp] %)}]]]

   [:div.space-y-1.sm:grid.sm:grid-cols-4.sm:gap-2.sm:space-y-0.mt-3
    [:div
     [:label.block.text-sm.font-medium.text-gray-900.sm:mt-px.sm:pt-2
      [:div.flex
       (tr :event/start)
       [:span.ml-1.text-primary
        "*"]]]]
    [:div.sm:col-span-3.flex.space-x-2
     [datepicker
      {:disabled? (= (:action @state) :view)
       :selected-date (get-in @state [:event :start])
       :on-change #(swap! state assoc-in [:event :start]
                          (parse (format (get-in @state [:event :start]) "HH:mm") "HH:mm" %))}]
     [time-select
      {:disabled? (= (:action @state) :view)
       :start-time "06:00"
       :end-time "23:30"
       :selected {:id (format (get-in @state [:event :start]) "HH:mm")
                  :name (format (get-in @state [:event :start])  "HH:mm")}
       :on-change #(swap! state assoc-in [:event :start]
                          (parse % "HH:mm" (get-in @state [:event :start])))}]]]

   [:div.space-y-1.sm:grid.sm:grid-cols-4.sm:gap-2.sm:space-y-0.mt-3
    [:div
     [:label.block.text-sm.font-medium.text-gray-900.sm:mt-px.sm:pt-2
      [:div.flex
       (tr :event/end)
       [:span.ml-1.text-primary
        "*"]]]]
    [:div.sm:col-span-3.flex.space-x-2
     [datepicker
      {:disabled? (= (:action @state) :view)
       :selected-date  (get-in @state [:event :end])
       :on-change #(swap! state assoc-in [:event :end]
                          (parse (format (get-in @state [:event :end]) "HH:mm") "HH:mm" %))}]
     [time-select
      {:disabled? (= (:action @state) :view)
       :start-time "06:00"
       :end-time "23:30"
       :selected {:id (format (get-in @state [:event :end]) "HH:mm" )
                  :name (format (get-in @state [:event :end]) "HH:mm")}
       :on-change #(swap! state assoc-in [:event :end]
                          (parse % "HH:mm" (get-in @state [:event :end])))}]]]

   [:div.space-y-1.sm:grid.sm:grid-cols-4.sm:gap-2.sm:space-y-0
    [:div
     [:label.block.text-sm.font-medium.text-gray-900.sm:mt-px.sm:pt-2
      (tr :event/floorplan-url)]]
    [:div.sm:col-span-3
     [input
      {:name "floorplan"
       :type "url"
       :disabled? (= (:action @state) :view)
       :default-value (get-in @state [:event :floorplanUrl])
       :on-change #(swap! state assoc-in [:event :floorplanUrl] %)}]]]

   [:div.space-y-1.sm:grid.sm:grid-cols-3.sm:gap-4.sm:space-y-0.mt-3
    [button
     {:on-click #(let [event (assoc (:event @state)
                                    :start (formatISO (:start (:event @state)))
                                    :end (formatISO (:end (:event @state))))]
                   (do
                     (re-frame/dispatch
                      (case (:action @state)
                        :add [::event-events/create-event {:event event}]
                        :delete [::event-events/delete-event {:event event}]
                        :edit [::event-events/update-event {:event event}]
                        ""))
                     (reset! state {:is-open? false
                                    :event nil
                                    :action nil})))}
     (case (:action @state)
       :add (tr :action/create)
       :delete (tr :action/delete)
       :edit (tr :action/save)
       "")]]])

(defn content []
  (let [drawer-state (reagent/atom {:is-open? false
                                    :event nil
                                    :action :edit})]
    (fn []
      (let [default-event {:organizationId (:id (listen ::subs/organization))
                           :name ""
                           :nameJp ""
                           :floorplanConfig {}
                           :start (parse "10:00" "HH:mm" (js/Date.))
                           :end (parse "17:30" "HH:mm" (addDays (js/Date.) 7))}]
        [:div
         [drawer
          {:state drawer-state
           :title (case (:action @drawer-state)
                    :add (tr :action/add-fn (tr :event))
                    :delete (tr :action/delete-fn (tr :event))
                    :edit (tr :action/edit-fn (tr :event))
                    "")
           :content [event-drawer-content
                     {:state drawer-state}]}]
         [:div.px-4.pt-6
          [:div.sm:flex.sm:items-center
           [:div.sm:flex-auto]
           [:div.mt-4.sm:mt-0.sm:ml-16.sm:flex-none
            [button
             {:on-click #(reset! drawer-state {:is-open? true
                                               :event default-event
                                               :action :add})}
             (tr :action/add-fn (tr :event))]]]]
         [:div.divide-y.divide-gray-200
          [:div.py-6.px-4
           [table
            {:headers [{:title (tr :event/name)
                        :key :name
                        :render-cell (fn [name row]
                                       [:div.flex.flex-col
                                        [:span.font-semibold
                                         {:class (if (= (:id (listen ::event-organizer-subs/selected-event)) (:id row))
                                                   "text-primary-500"
                                                   "text-black")}
                                         name]
                                        [:span.text-gray-500
                                         (:nameJp row)]])}
                       {:title (tr :event/start)
                        :key :start
                        :render-cell (fn [start row]
                                       (format start "PPP"))}
                       {:title (tr :event/end)
                        :key :end
                        :render-cell (fn [end row]
                                       (format  end "PPP"))}]
             :rows (->> (listen ::event-organizer-subs/events)
                        (sort-by :start)
                        (reverse))
             :actions [{:name :select
                        :text (tr :action/select)
                        :on-click #(re-frame/dispatch [::event-events/select-event %])}
                       {:name :edit
                        :text (tr :action/edit)
                        :on-click #(reset! drawer-state {:is-open? true
                                                         :event %
                                                         :action :edit})}
                       {:name :delete
                        :text (tr :action/delete)
                        :on-click #(reset! drawer-state {:is-open? true
                                                         :event %
                                                         :action :delete})}]}]]
          [:div.pt-6.divide-y.divide-gray-200
           [:div.py-4.px-4.flex.justify-end.sm:px-6
            [button
             {:type "submit"}
             (tr :action/save)]]]]]))))
